import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./Loading.scss";

const Loading = () => {
  return (
    <div>
      <div className="frame-circularProgress">
        <CircularProgress />
      </div>
      <div>
        <h3>Loading Data...</h3>
      </div>
    </div>
  );
};

export default Loading;

export const ButtonLoading = () => {
  return (
    <div  >
      <CircularProgress style={{color:"white",width:"30px",height:"30px",marginTop:"3px"}} />
    </div>
  );
};
